module.exports = __webpack_public_path__ + "static/media/real3.4e0a0058.jpg";